/* SPDX-FileCopyrightText: 2014-present Kriasoft */
/* SPDX-License-Identifier: MIT */

import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ModelType =
  | "recommended"
  | "povchat"
  | "chatgpt"
  | "deepseek"
  | "mistral"
  | "wizardlm"
  | "hermes"
  | "claude"
  | "llama8b"
  | "lunaris"
  | "llama70b"
  | "gemini"
  | "glm";

interface ModelState {
  selectedModel: ModelType;
  setSelectedModel: (model: ModelType) => void;
}

export const useModelStore = create<ModelState>()(
  persist(
    (set) => ({
      selectedModel: "recommended", // Default to creator's recommended model
      setSelectedModel: (model: ModelType) => set({ selectedModel: model }),
    }),
    {
      name: "model-storage", // unique name for localStorage key
    },
  ),
);
